export default "__VITE_ASSET__CllePA86__"